import styles from './FJAIAudioRight.module.less';
import FJSwiper from '../../../../common/combineComponents/FJSwiper/FJSwiper.jsx';
import FJAudioPresetItem from './FJAudioPresetItem.jsx';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJAIAudioHistoryContainer from '../container/FJAIAudioHistoryContainer.jsx';
import FJConstant from '../../../../constants/FJConstant.js';
import FJAutoLoading from '../../../../common/components/FJLoading/FJAutoLoading.jsx';
import FJButton from '../../../../common/components/FJButton/FJButton.jsx';
import FJOppsIcon from '../../../../assets/svg/oops.svg?react';
import { useState } from 'react';
import fireBase64 from '../../../../assets/base64/fire.js';
import PropTypes from 'prop-types';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller.jsx';

const FJAIAudioRight = props => {
    const {
        historyList = [],
        historyListLoadStatus,
        onRetry,
        presetList,
        onUsePresetInfo,
        tabIndex,
        subTabIndex,
    } = props;
    const [isOpenSwiper, setIsOpenSwiper] = useState(true);

    const renderItem = item => {
        return (
            <FJAudioPresetItem
                key={item.name}
                item={item}
                onUse={() => {
                    onUsePresetInfo(item);
                }}
                showPrompt={tabIndex !== 1}
                setIsOpenSwiper={setIsOpenSwiper}
            />
        );
    };

    const aiTitle =
        tabIndex === 2
            ? FJLocalStore._('FlexClip-ai-sound-effects')
            : subTabIndex === 0
              ? FJLocalStore._('FlexClip-ai-music')
              : FJLocalStore._('FlexClip-ai-instrumental');

    const aiDesc =
        tabIndex === 2
            ? FJLocalStore._('innovative-ai-sound-effects-samples')
            : subTabIndex === 0
              ? FJLocalStore._('innovative-ai-music-samples')
              : FJLocalStore._('innovative-ai-instrumental-samples');

    return (
        <div className={styles.app_right}>
            {historyListLoadStatus === FJConstant.LOADING && (
                <div className={styles.state_box}>
                    <FJAutoLoading shown strokeColor='#9FA2AF' />
                </div>
            )}
            {historyListLoadStatus === FJConstant.ERROR && (
                <div className={styles.state_box}>
                    <FJOppsIcon />
                    <div className={styles.retry_desc}>{FJLocalStore._('unknown-error-please-try-again')}</div>
                    <FJButton type='white' text='retry' className={styles.retry_btn} onClick={onRetry} />
                </div>
            )}
            {historyListLoadStatus === FJConstant.SUCCESS && historyList.length > 0 && <FJAIAudioHistoryContainer />}
            {historyListLoadStatus === FJConstant.SUCCESS && historyList.length === 0 && (
                <div className={styles.default_box}>
                    <FJVerticalScroller className={styles.scroller}>
                        <div className={styles.title}>
                            {aiTitle}
                            <img src={fireBase64} alt='' />
                        </div>
                        <div className={styles.desc}>{aiDesc}</div>
                        <div className={styles.swiper_box}>
                            <FJSwiper
                                direction='reverse'
                                renderItem={renderItem}
                                list={presetList}
                                isOpenSwiper={isOpenSwiper}
                            />
                        </div>
                    </FJVerticalScroller>
                </div>
            )}
        </div>
    );
};

FJAIAudioRight.propTypes = {
    historyList: PropTypes.array,
    historyListLoadStatus: PropTypes.string,
    onRetry: PropTypes.func,
    presetList: PropTypes.array,
    onUsePresetInfo: PropTypes.func,
    tabIndex: PropTypes.number,
    subTabIndex: PropTypes.number,
};
export default FJAIAudioRight;
